import { tokenSubTypes, tokenTypes } from '../Constants.js';
import Factory from './Factory.js';
import Util from './Util.js';
export default {
  type: 'ExpressionField.function',
  tokenize: (field, context) => {
    if (!field?.absoluteLocation) {
      return [];
    }
    const toReturn = [{
      startIndex: field.absoluteLocation.startIndex,
      endIndex: field.absoluteLocation.startIndex + field.func.length,
      type: tokenTypes.IDENTIFIER,
      subType: tokenSubTypes.FUNCTION_NAME
    }, ...Util.handleAlias(field, context)];
    field.args?.forEach(argField => {
      toReturn.push(...Factory.create(argField));
    });
    if (Array.isArray(field.commaLocations)) {
      toReturn.push(...field.commaLocations.map(commaLocation => ({
        startIndex: commaLocation.absolute,
        endIndex: commaLocation.absolute + 1,
        type: tokenTypes.DELIMITER,
        subType: tokenSubTypes.COMMA
      })));
    }
    return toReturn;
  }
};